import { connect } from 'react-redux';
import { fetchRegisterApplicant } from './../../../reducers/account/createAccount';
import RegisterApplicant from './RegisterApplicant';
import { getTranslation } from "../../../reducers/common/localization";
import { getSubmitFormSuccessStatus } from './../../../reducers/common/submitForm';
import { showModal, MODAL_LICENSE_AGREEMENT } from "../../../reducers/common/activeModal";

const mapStateToProps = (state) => {
    return {
        success: getSubmitFormSuccessStatus(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRegister: (data) => {
            dispatch(fetchRegisterApplicant(data));
        },
        onShowLicenseAgreement: () => dispatch(showModal({ modalKey: MODAL_LICENSE_AGREEMENT }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterApplicant);



// WEBPACK FOOTER //
// ./src/components/accountManagement/registerApplicant/RegisterApplicant.container.js